<template>
  <div class="shadow" :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div id="errorNotification" class="col-md-12">
          <base-alert v-if="errorMessage != null" type="danger">
            <span class="alert-inner--text"> {{errorMessage}}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
          <base-alert v-if="successMessage != null" type="success">
            <span class="alert-inner--text"> {{successMessage}}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
        </div>
        <div class="col-md-3">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            Notifications
          </h3>
        </div>
        <div class="col-md-9 text-right">
          <a-popconfirm v-if="hasSelectedUnread" title="Mark selected system notifications as read?" @confirm="markSelectedAsRead" okText="Mark Read" cancelText="Cancel">
            <button type="button" class="btn btn-sm btn-default mr-2">
              Mark Selected as Read
            </button>
          </a-popconfirm>
          <base-dropdown class="nav-link pr-0 float-right" position="right">
            <div class="media align-items-center" slot="title">
              <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
            </div>
            <template>
              <div class=" dropdown-header noti-title">
                <h6 class="text-overflow m-0">ACTIONS</h6>
              </div>
              <div v-if="accessRights.includes('E')" class="dropdown-item"
                @click.prevent="showActionDrawer('export_list')">
                <i class="fa fa-download"></i>
                <span>Export</span>
              </div>
            </template>
          </base-dropdown>
        </div>
      </div>
    </div>

    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
      <div v-if="profileAction == 'export_list'">
        <h6 class="heading-small text-muted mb-4">Export Options</h6>
        <div>
          <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
            Export All
          </base-radio>
          <base-radio name="1" class="mb-3" v-model="filterStatus" value="1">
            Export Current Page
          </base-radio>
          <base-radio name="3" class="mb-3" v-model="filterStatus" value="3">
            Export Filtered
          </base-radio>
        </div>
        <div style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        ">
          <button type="button" class="btn btn-primary float-right" @click.prevent="download">
            Export
          </button>
        </div>
      </div>
    </a-drawer>

    <a-drawer :width="520" placement="right" @close="closeNotificationDrawer" :visible="notificationDrawerVisible">
      <div v-if="selectedNotification != null">
        <h6 class="heading-small text-muted mb-4">Details</h6>
        <dl class="notification-details">
          <dt>Site</dt>
          <dd>{{ selectedNotification.site }}</dd>
          <dt>Activity</dt>
          <dd>{{ selectedNotification.activity }}</dd>
          <dt>Terminal</dt>
          <dd>{{ selectedNotification.terminal_name }}</dd>
          <dt>Cashier</dt>
          <dd>{{ selectedNotification.cashier_name }}</dd>
          <dt>Date</dt>
          <dd>{{ formatDate(selectedNotification.date) }}</dd>
          <dt>Transaction No.</dt>
          <dd>{{ selectedNotification.trans_id }}</dd>
          <dt>Customer</dt>
          <dd>{{ selectedNotification.customer_name || 'Not Specified'}}</dd>
          <!-- <dt>Status</dt>
          <dd>{{ selectedNotification.status }}</dd>
          <dt>Viewed</dt>
          <dd>{{ selectedNotification.is_viewed == 1 ? 'Yes' : 'No' }}</dd> -->
        </dl>

        <div v-if="selectedNotification.meta_data != null">
          <h6 class="heading-small text-muted mb-3">Meta Data</h6>
          <div class="notification-meta">
            <template v-if="Array.isArray(parsedMetaData(selectedNotification.meta_data))">
              <ul class="mb-0 pl-3">
                <li v-for="(item, index) in parsedMetaData(selectedNotification.meta_data)" :key="index">
                  {{ item }}
                </li>
              </ul>
            </template>
            <template v-else-if="typeof parsedMetaData(selectedNotification.meta_data) == 'object'">
              <div v-for="(value, key) in parsedMetaData(selectedNotification.meta_data)" :key="key" class="notification-meta-row">
                <strong>{{ formatMetaKey(key, selectedNotification.activity) }}</strong>
                <ul v-if="Array.isArray(value)" class="mb-0 pl-3">
                  <li v-for="(item, index) in value" :key="index">
                    {{ formatMetaValue(item) }}
                  </li>
                </ul>
                <span v-else>{{ formatMetaValue(value) }}</span>
              </div>
            </template>
            <template v-else>
              {{ parsedMetaData(selectedNotification.meta_data) }}
            </template>
          </div>
        </div>
      </div>
    </a-drawer>

    <div class="table-responsive">
        <vuetable ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="tableVields" :sort-order="sortOrder"
          :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data"
          no-data-template="Empty" :row-class="rowClass"
          @vuetable:checkbox-toggled="syncCheckedItems"
          @vuetable:checkbox-toggled-all="syncCheckedItems"
          @vuetable:load-error="onLoadError" @vuetable:pagination-data="onPaginationData">
          <template slot="activity" slot-scope="props">
            <span class="notification-activity">
              <span v-if="props.rowData.is_viewed != 1" class="notification-unread-dot"></span>
              {{ props.rowData.activity }}
            </span>
          </template>
          <template slot="actions" slot-scope="props">
            <center>
              <button class="btn btn-success btn-sm" @click.prevent="openNotificationDrawer(props.rowData)">
                View
              </button>
            </center>
          </template>
        </vuetable>
    </div>

    <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
        </vuetable-pagination>
      </div>
    </div>

  </div>
</template>

<script>

 import axios from "axios";
 import { mapState, mapActions } from 'vuex'

  import Vuetable from "vuetable-2/src/components/Vuetable";
  import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
  import secureStorage from '../../controllers/secureStorage';
  import HTTPRequest from '../../controllers/httpRequest.js';
  import moment from "moment";

  var component_x;

  export default {
    name: 'notifications-table',
    props: {
      type: {
        type: String
      },
      title: String,
        siteId: {
        type: [Number, String],
        default: secureStorage.getItem("defaultSiteId")
      },
    },
    components: {
      Vuetable,
      VuetablePagination
    },
    computed: {
      ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'serverType', 'profileId']),
      hasSelectedUnread() {
        return this.selectedUnreadNotifications().length > 0
      }
    },
    data() {
      return {
        accessRights: [],
        drawerVisible: false,
        notificationDrawerVisible: false,
        selectedNotification: null,
        loadedData: [],
        checkedItems: [],
        userProductGroupAccess: [],
        filterStatus: "",
        profileAction: "",
        errorMessage: null,
        successMessage: null,
        componentKey: 0,
        visible: false,
        availableFields: [],
        apiURL: "",
        fields: ["__checkbox", "site", {name: "__slot:activity", title: "activity"}, {name: "terminal_name", title: "terminal name"}, {name: "cashier_name", title: "cashier name"}, { name: "date",  callback: (value) => this.formatDate(value) }, { name: "trans_id", title: "transaction no" },  { name: "customer_name", title: "customer" }, { name: "meta_data", title: "meta data" }, "__slot:actions"],        
          sortOrder: [{
          field: "date",
          direction: "desc"
        }],
        tableVields:  ["__checkbox", "site", {name: "__slot:activity", title: "activity"}, {name: "terminal_name", title: "terminal name"}, {name: "cashier_name", title: "cashier name"}, { name: "date",  callback: (value) => this.formatDate(value) }, { name: "trans_id", title: "transaction no" }, "__slot:actions"], 
        httpOptions: {
          headers: {
            Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web"
          }
        },
        css: {
          table: {
            tableClass: 'table table-sm table-striped table-bordered table-hovered',
            loadingClass: 'loading'
          },
          pagination: {
            infoClass: 'pull-right',
            wrapperClass: 'vuetable-pagination pull-right',
            activeClass: 'btn-primary btn-sm',
            disabledClass: 'disabled',
            pageClass: 'btn btn-border',
            linkClass: 'btn btn-border',
            icons: {
              first: '',
              prev: '',
              next: '',
              last: '',
            },
          }
        }
      }
    },
    watch: {
      currentApiURL: function () {
        this.$refs.vuetable.resetData()
        this.apiURL = this.defaultApiURL()
        this.accessRights = this.$attrs.accessRights
      },
      parameters: function () {
        this.apiURL = this.endPoint + 'system_notifications'
        this.apiURL = this.apiURL + this.parameters
        this.$refs.vuetable.selectedTo = []		
        this.checkedItems = []
      }
    },
    methods: {
      closeDrawer(){
        this.onClose()
      },
      defaultApiURL() {
        const dateFrom = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        const dateTo = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')

        return this.endPoint + 'system_notifications' +
          '?site_id=' + this.siteId +
          '&date_from=' + encodeURIComponent(dateFrom) +
          '&date_to=' + encodeURIComponent(dateTo)
      },
      refreshPage() {
        this.onClose()
        this.$refs.vuetable.refresh()
        this.successMessage = "Successful Operation"
        this.errorMessage = null
      },
      onClose() {
        this.drawerVisible = false;
        this.visible = false
        this.componentKey++
      },
      closeNotificationDrawer() {
        this.notificationDrawerVisible = false
        this.selectedNotification = null
      },
      formatDate(value){
        let formattedDate = moment(value).format("YYYY-MM-DD")
        return formattedDate;
      },
      rowClass(dataItem) {
        return dataItem.is_viewed == 1 ? "" : "notification-unread-row"
      },
      parsedMetaData(value) {
        if(typeof value == "string"){
          try {
            return JSON.parse(value)
          } catch (error) {
            return value
          }
        }

        return value
      },
      formatMetaKey(value, activity = null) {
        let normalizedKey = value.toString().replace(/_/g, "").toLowerCase()
        if(normalizedKey == "idnumber"){
          return "ID Number"
        }

        if(normalizedKey == "customercode" && this.isSupercardDiscountActivity(activity)){
          return "Card Number"
        }

        return value.toString()
          .replace(/_/g, " ")
          .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      },
      isSupercardDiscountActivity(activity) {
        let normalizedActivity = (activity || "").toString().trim().toLowerCase()
        return ["supercard discount", "exceed supercard discount"].includes(normalizedActivity)
      },
      formatMetaValue(value) {
        if(value == null){
          return ""
        }
        if(typeof value == "object"){
          return JSON.stringify(value)
        }

        return value
      },
      removeMessage(type) {
        if (type == 'error')
          this.errorMessage = null
        else
          this.successMessage = null
      },
      async showActionDrawer(action) {
        this.profileAction = action
        this.visible = true
        this.drawerVisible = true;
      },
      async onPaginationData(paginationData) {
        this.$refs.pagination.setPaginationData(paginationData);
        this.loadedData = paginationData.data
        this.checkedItems = []
      },
      async onLoadError(error) {
        // request for new token or reauthenticate
        if (error.response.status == 401) {
          var auth_response = await HTTPRequest.authenticate(component_x.endPoint)
          if (auth_response["status"] == "Ok") {
            this.$router.go();
          } else {
            alert("Cannot get access token. Please login again.")
            this.$router.push("/")
          }
        } else {
          if(error.response.data.error == "Session expired"){
              alert("Session is already expired. Please login again.")
              document.getElementById("logoutButton").click()
          }
        }
      },
      onChangePage(page) {
        this.$refs.vuetable.changePage(page);
      },
      syncCheckedItems(){
        this.checkedItems = this.$refs.vuetable.selectedTo || []
      },
      selectedUnreadNotifications(){
        let checkedIds = this.checkedItems.map(id => id.toString())
        let loadedData = Array.isArray(this.loadedData) ? this.loadedData : []
        return loadedData.filter(item => checkedIds.includes(item.id.toString()) && item.is_viewed != 1)
      },
      async setNotificationAsViewed(loadedData){
        let data = loadedData.filter(item => item.is_viewed != 1).map(item => {
          return item.id
        })
        if(data.length){
          let viewedNotificationPayload = {data};
          let post_request = await HTTPRequest.postRequest(this.endPoint + 'system_notifications/mark_as_viewed', null, viewedNotificationPayload)
          if(post_request != undefined && post_request["error"] != undefined){
              this.errors = post_request["error"].split(",")
          }
        }
        
      },
      async openNotificationDrawer(notification){
        this.selectedNotification = notification
        this.notificationDrawerVisible = true

        if(notification.is_viewed != 1){
          await this.setNotificationAsViewed([notification])
          notification.is_viewed = 1
        }
      },
      async markSelectedAsRead(){
        let unreadNotifications = this.selectedUnreadNotifications()
        if(unreadNotifications.length == 0){
          return
        }

        await this.setNotificationAsViewed(unreadNotifications)
        unreadNotifications.forEach(notification => {
          notification.is_viewed = 1
        })
        this.$refs.vuetable.selectedTo = []
        this.checkedItems = []
        this.$refs.vuetable.refresh()
        this.successMessage = "Selected notifications marked as read"
        this.errorMessage = null
      },
      download() {
        var payload = {};
        var additional_parameters = "";
        var baseUrl = this.endPoint + 'system_notifications' + "/download?file_type=csv";
        if (this.filterStatus == "0") {
          // All
          payload["type"] = "all";
        } else if (this.filterStatus == "1") {
          // Current Page
          var ids = this.$refs.vuetable.tableData.map(({ id }) => id)
          payload["type"] = "current_page";
          if (ids == 0) {
            this.errors.push('No Record(s)');
            return;
          } else {
            payload["ids"] = ids
          }
        } else {
          // Filtered
          payload["type"] = "filtered";
          additional_parameters = this.parameters;
        }

        var exportFields = this.fields.filter(field => field != "__slot:actions" && field != "__checkbox");
        payload["fields"] = exportFields;
        payload["site_id"] = this.siteId;
        additional_parameters = additional_parameters.replace("?", "&");

        axios({
          url: baseUrl + additional_parameters,
          method: "POST",
          responseType: "blob", // important
          headers: {
            Authorization: "Bearer " + secureStorage.getItem("accessToken"),
            "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"
          },
          data: payload,
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "file.csv");
          document.body.appendChild(link);
          link.click();
          this.onClose();
          this.filterStatus = null;
          this.successMessage = "Download successful";
        });
    },

    },
    mounted: async function () {
      component_x = this;
      var userId = secureStorage.getItem("userId")
      this.accessRights = this.$attrs.accessRights;
      this.apiURL = this.defaultApiURL()
    }
  }
</script>

<style>
.notification-unread-row {
  font-weight: 600;
  background-color: #f8fbff;
}

.notification-activity {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.notification-unread-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #2d8cf0;
  display: inline-block;
  flex: 0 0 8px;
}

.notification-details dt {
  color: #8898aa;
  font-size: 12px;
  margin-top: 12px;
  text-transform: uppercase;
}

.notification-details dd {
  margin-bottom: 0;
}

.notification-meta {
  background-color: #f7fafc;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 12px;
}

.notification-meta-row {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 12px;
  padding: 6px 0;
}

.notification-meta-row strong {
  color: #525f7f;
  font-weight: 600;
  text-transform: capitalize;
}
</style>
